import { createSlice } from '@reduxjs/toolkit';
import { fetchConsultantAllOrders } from './features';

export const consultantOrderList = createSlice({
  name: 'consultantOrderList',
  initialState: {
    delayedOrders: [],
    inProgressOrders: [],
    nonAttributedOrders: [],
    validatedOrders: [],
    isLoading: true,
    isError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConsultantAllOrders.fulfilled, (state, { payload }) => {
        state.delayedOrders = payload?.delayedProjects ?? [];
        state.inProgressOrders = payload?.inProgressProjects ?? [];
        state.validatedOrders = payload?.validatedProjects ?? [];
        state.nonAttributedOrders = payload?.nonAttributedProjects ?? [];
        state.isLoading = false;
        state.isError = false;
      })
      .addCase(fetchConsultantAllOrders.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchConsultantAllOrders.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export default consultantOrderList.reducer;

export const consultantOrderListSelector = (state) => state.consultantOrderList;
